import type { OutletDeviceCounts } from '@photobooth/types';

interface OutletDeviceStatusGridProps {
  deviceCounts?: OutletDeviceCounts;
}

export function OutletDeviceStatusGrid({ deviceCounts }: OutletDeviceStatusGridProps) {
  const counts: OutletDeviceCounts = deviceCounts ?? {
    capture: 0,
    customer: 0,
    cashier: 0,
  };

  return (
    <div className="grid grid-cols-3 gap-3">
      <div className="text-center p-3 bg-gray-50 rounded">
        <div className="text-2xl mb-1">📸</div>
        <div className="text-xs text-text-muted">Capture</div>
        <div
          className={`text-xs font-medium ${
            counts.capture > 0 ? 'text-green-600' : 'text-gray-400'
          }`}
        >
          {counts.capture} Online
        </div>
      </div>

      <div className="text-center p-3 bg-gray-50 rounded">
        <div className="text-2xl mb-1">🧑‍💻</div>
        <div className="text-xs text-text-muted">Customer</div>
        <div
          className={`text-xs font-medium ${
            counts.customer > 0 ? 'text-green-600' : 'text-gray-400'
          }`}
        >
          {counts.customer} Online
        </div>
      </div>

      <div className="text-center p-3 bg-gray-50 rounded">
        <div className="text-2xl mb-1">💵</div>
        <div className="text-xs text-text-muted">Cashier</div>
        <div
          className={`text-xs font-medium ${
            counts.cashier > 0 ? 'text-green-600' : 'text-gray-400'
          }`}
        >
          {counts.cashier} Online
        </div>
      </div>
    </div>
  );
}

